import React from 'react'
import Header from './Header'
import WhatWeDo from './WhatWeDo'
import About from './About'
import Landingscreen from './Landingscreen'
import Services from './Services'
import Contact from './Contact'
import Footer from './Footer'
import NewEngineeringResponse from './NewEngineeringResponse'
import NewAbout from './NewAbout'

const Home = () => {
    return (
        <div>

            <Header />

            <section id="home">
                <Landingscreen />
            </section>

            <section id="About">
                <About />
                <NewAbout />

            </section>

            <section id="Services">
                <Services />
                <NewEngineeringResponse />

            </section>


            <section id="capabilities">
                <WhatWeDo />
            </section>




            <section id="Contact">
                <Contact />

            </section>

            <Footer />

        </div>
    )
}

export default Home